import script from "./Pension-Provider-Delegation.vue?vue&type=script&setup=true&lang=js"
export * from "./Pension-Provider-Delegation.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__